import { withStyles } from '@material-ui/core/styles';
import ChatStatusDrawer from './ChatStatusDrawer';
import styles from './ChatStatusDrawer.styles';

export default withStyles(styles)(ChatStatusDrawer);
